import style from './NotificationCenterListItem.css';

export default function NotificationCenterListItem({
  className = '',
  notification,
  onClick,
}) {
  function parseDate(stringDate) {
    let date = new Date(stringDate);
    if (isNaN(date.getTime())) {
      console.log('valid date', date);
      return '';
    }

    console.log('invalid date', date);
    return date.toLocaleDateString();
  }

  return (
    <div className={`${className} ${style['notification-center-list-item']}`}>
      <div className={style.container} onClick={onClick}>
        <div className={style.topContainer}>
          <div className={style.left}>
            <p className={style.title}>{notification.title}</p>
          </div>
          <div className={style.right}>
            <p className={style.date}>{parseDate(notification.date)}</p>
          </div>
        </div>
        <div className={style.bottomContainer}>
          <p className={style.body}>{notification.body}</p>
        </div>
      </div>
      <div />
    </div>
  );
}
